var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"the-shape d-flex flex-column",class:[
    { 'rounded-circle pa-4': _vm.$vuetify.breakpoint.mdAndUp && !_vm.isSectionThree },
    { 'rounded-xl pa-2': !_vm.$vuetify.breakpoint.mdAndUp && !_vm.isSectionThree },
    `the-shape-${_vm.circleInd}${_vm.isSectionThree}`,
    { 'transparent align-center align-md-start': _vm.isSectionThree },
    { 'v-box-shadow text-center align-center': !_vm.isSectionThree },
  ],attrs:{"width":_vm.$vuetify.breakpoint.mdAndUp && !_vm.isSectionThree
      ? '215px'
      : _vm.$vuetify.breakpoint.smOnly && !_vm.isSectionThree
      ? '150px'
      : _vm.isSectionThree
      ? '170px'
      : '',"height":_vm.$vuetify.breakpoint.mdAndUp && !_vm.isSectionThree
      ? '200px'
      : _vm.$vuetify.breakpoint.smOnly && !_vm.isSectionThree
      ? '150px'
      : _vm.isSectionThree
      ? ''
      : '120px',"flat":_vm.isSectionThree}},[_c('div',{staticClass:"text-md-h3 font-weight-bold",class:[_vm.isSectionThree ? 'text-h4' : 'pt-5 pt-md-10 text-h5 text-sm-h4'],style:([_vm.isSectionThree ? { color: '#7cb518 ' } : { color: '#134611' }])},[_vm._v(" "+_vm._s(_vm.start)+_vm._s(_vm.circle.title.match(/\D/)[0])+" ")]),_c('div',{class:[
      _vm.circle.hasLargeText
        ? 'text-sm-body-2 text-md-body-2 custom-small--text'
        : 'text-sm-body-2 text-md-body-1',
      { 'font-weight-bold text-h6': _vm.isSectionThree },
      _vm.isSectionThree ? 'text-body-1' : 'text-caption',
    ],style:([!_vm.isSectionThree ? { color: '#7cb518 ' } : { color: '' }]),domProps:{"innerHTML":_vm._s(_vm.circle.text)}}),(_vm.isSectionThree)?_c('div',{staticClass:"line mt-3"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }